/* Cozy Warmth - global behaviour
   Mobile nav, cart drawer, AJAX cart, scroll reveal, sticky header. */

(function () {
  'use strict';

  var money = function (cents) {
    var format = window.themeSettings && window.themeSettings.moneyFormat;
    var amount = (cents / 100).toFixed(2);
    if (!format) return '$' + amount;
    return format.replace(/\{\{\s*(\w+)\s*\}\}/, function (_, key) {
      if (key === 'amount_no_decimals') return Math.round(cents / 100).toString();
      if (key === 'amount_with_comma_separator') return amount.replace('.', ',');
      return amount;
    });
  };
  window.formatMoney = money;

  /* ------------------------------------------------------------ focus trap */

  function trapFocus(container) {
    var focusables = container.querySelectorAll(
      'a[href], button:not([disabled]), input:not([disabled]), select, textarea, [tabindex]:not([tabindex="-1"])'
    );
    if (!focusables.length) return function () {};
    var first = focusables[0];
    var last = focusables[focusables.length - 1];

    function onKey(event) {
      if (event.key !== 'Tab') return;
      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    }

    container.addEventListener('keydown', onKey);
    first.focus();
    return function () {
      container.removeEventListener('keydown', onKey);
    };
  }

  /* ------------------------------------------------------------- overlays  */

  var overlay = document.querySelector('[data-drawer-overlay]');
  var releaseFocus = null;
  var lastTrigger = null;

  function openPanel(panel, trigger) {
    if (!panel) return;
    closeAllPanels(true);
    panel.dataset.open = 'true';
    if (overlay) overlay.dataset.open = 'true';
    document.body.style.overflow = 'hidden';
    lastTrigger = trigger || null;
    releaseFocus = trapFocus(panel);
  }

  function closeAllPanels(silent) {
    document.querySelectorAll('[data-panel][data-open="true"]').forEach(function (panel) {
      panel.dataset.open = 'false';
    });
    if (overlay) overlay.dataset.open = 'false';
    document.body.style.overflow = '';
    if (releaseFocus) {
      releaseFocus();
      releaseFocus = null;
    }
    if (!silent && lastTrigger) {
      lastTrigger.focus();
      lastTrigger = null;
    }
  }

  document.addEventListener('click', function (event) {
    var opener = event.target.closest('[data-panel-open]');
    if (opener) {
      var target = document.querySelector('[data-panel="' + opener.dataset.panelOpen + '"]');
      if (target) {
        event.preventDefault();
        openPanel(target, opener);
      }
      return;
    }
    if (event.target.closest('[data-panel-close]')) {
      event.preventDefault();
      closeAllPanels();
    }
  });

  if (overlay) overlay.addEventListener('click', function () { closeAllPanels(); });

  document.addEventListener('keydown', function (event) {
    if (event.key === 'Escape') closeAllPanels();
  });

  /* --------------------------------------------------------- sticky header */

  var header = document.querySelector('[data-header]');
  if (header) {
    var onScroll = function () {
      header.classList.toggle('is-scrolled', window.scrollY > 8);
    };
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
  }

  /* --------------------------------------------------------- scroll reveal */

  function initReveal(root) {
    var items = (root || document).querySelectorAll('.reveal:not(.is-visible)');
    if (!items.length) return;
    if (!('IntersectionObserver' in window)) {
      items.forEach(function (el) { el.classList.add('is-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.05 });
    items.forEach(function (el) { observer.observe(el); });
  }
  initReveal();
  document.addEventListener('shopify:section:load', function (event) { initReveal(event.target); });

  /* -------------------------------------------------------------- AJAX cart */

  var cartDrawer = document.querySelector('[data-panel="cart"]');

  function refreshCart() {
    return fetch(window.Shopify.routes.root + '?section_id=cart-drawer')
      .then(function (response) { return response.text(); })
      .then(function (html) {
        var parsed = new DOMParser().parseFromString(html, 'text/html');
        var fresh = parsed.querySelector('[data-cart-contents]');
        var current = document.querySelector('[data-cart-contents]');
        if (fresh && current) current.innerHTML = fresh.innerHTML;
        return fetch(window.Shopify.routes.root + 'cart.js').then(function (r) { return r.json(); });
      })
      .then(function (cart) {
        document.querySelectorAll('[data-cart-count]').forEach(function (node) {
          node.textContent = cart.item_count;
          node.hidden = cart.item_count === 0;
        });
        document.dispatchEvent(new CustomEvent('cart:updated', { detail: { cart: cart } }));
        return cart;
      });
  }
  window.refreshCart = refreshCart;

  function addToCart(formData, button) {
    if (button) {
      button.classList.add('is-loading');
      button.dataset.originalText = button.textContent;
      button.textContent = 'Adding...';
    }
    // A JSON string body is used when add-ons ride along with the main item.
    var headers = { Accept: 'application/json' };
    if (typeof formData === 'string') headers['Content-Type'] = 'application/json';

    return fetch(window.Shopify.routes.root + 'cart/add.js', {
      method: 'POST',
      headers: headers,
      body: formData
    })
      .then(function (response) {
        return response.json().then(function (body) {
          if (!response.ok) throw new Error(body.description || body.message || 'Could not add to cart');
          return body;
        });
      })
      .then(function () {
        // A volume tier can carry a discount code. Apply it before we re-read the cart
        // so the drawer shows the discounted total straight away.
        var form = button && button.closest('form');
        var code = form && form.dataset.discountCode;
        if (!code) return null;
        return fetch(window.Shopify.routes.root + 'discount/' + encodeURIComponent(code), {
          credentials: 'same-origin'
        }).catch(function () {
          return null;
        });
      })
      .then(function () {
        return refreshCart();
      })
      .then(function () {
        if (cartDrawer && window.themeSettings.cartType === 'drawer') {
          openPanel(cartDrawer, button);
        } else {
          window.location.href = window.Shopify.routes.root + 'cart';
        }
      })
      .catch(function (error) {
        var target = button && button.closest('form');
        var box = target && target.querySelector('[data-form-error]');
        if (box) {
          box.textContent = error.message;
          box.hidden = false;
        } else {
          alert(error.message);
        }
      })
      .finally(function () {
        if (button) {
          button.classList.remove('is-loading');
          if (button.dataset.originalText) button.textContent = button.dataset.originalText;
        }
      });
  }
  window.addToCart = addToCart;

  /* ---------------------------------------------------------- add-ons     */

  document.addEventListener('change', function (event) {
    var addon = event.target.closest('[data-addon-id]');
    if (!addon) return;
    var row = addon.closest('.addon');
    if (row) row.classList.toggle('addon--active', addon.checked);
  });

  document.addEventListener('submit', function (event) {
    var form = event.target.closest('form[data-ajax-cart]');
    if (!form) return;
    event.preventDefault();

    var button = form.querySelector('[type="submit"]');
    var errorBox = form.querySelector('[data-form-error]');
    if (errorBox) errorBox.hidden = true;

    var formData = new FormData(form);
    var root = form.closest('[data-product-root]') || document;
    var addons = root.querySelectorAll('[data-addon-id]:checked');

    if (addons.length === 0) {
      addToCart(formData, button);
      return;
    }

    // cart/add.js takes several line items at once, so the add-ons go in the
    // same request and the drawer opens once with everything in it.
    var items = [
      {
        id: formData.get('id'),
        quantity: parseInt(formData.get('quantity'), 10) || 1
      }
    ];

    addons.forEach(function (addon) {
      items.push({ id: addon.dataset.addonId, quantity: 1 });
    });

    addToCart(JSON.stringify({ items: items }), button);
  });

  /* ------------------------------------------------------ cart line updates */

  function changeLine(key, quantity) {
    var contents = document.querySelector('[data-cart-contents]');
    if (contents) contents.classList.add('is-loading');
    return fetch(window.Shopify.routes.root + 'cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify({ id: key, quantity: quantity })
    })
      .then(function () {
        if (document.body.classList.contains('template-cart')) {
          window.location.reload();
          return null;
        }
        return refreshCart();
      })
      .finally(function () {
        var node = document.querySelector('[data-cart-contents]');
        if (node) node.classList.remove('is-loading');
      });
  }

  document.addEventListener('click', function (event) {
    var remove = event.target.closest('[data-cart-remove]');
    if (remove) {
      event.preventDefault();
      changeLine(remove.dataset.cartRemove, 0);
      return;
    }
    var step = event.target.closest('[data-qty-step]');
    if (step) {
      event.preventDefault();
      var wrap = step.closest('[data-qty]');
      var input = wrap.querySelector('input');
      var next = Math.max(
        parseInt(input.min || '1', 10),
        parseInt(input.value, 10) + parseInt(step.dataset.qtyStep, 10)
      );
      input.value = next;
      input.dispatchEvent(new Event('change', { bubbles: true }));
    }
  });

  document.addEventListener('change', function (event) {
    var input = event.target.closest('[data-cart-qty]');
    if (!input) return;
    changeLine(input.dataset.cartQty, parseInt(input.value, 10) || 0);
  });

  /* ------------------------------------------------------------ cart note   */

  var noteTimer;
  document.addEventListener('input', function (event) {
    var note = event.target.closest('[data-cart-note]');
    if (!note) return;
    clearTimeout(noteTimer);
    noteTimer = setTimeout(function () {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ note: note.value })
      });
    }, 600);
  });

  /* ----------------------------------------------------------- email popup */

  var popup = document.querySelector('[data-popup]');
  if (popup) {
    var popupKey = popup.dataset.storageKey;
    var rememberDays = parseInt(popup.dataset.rememberDays, 10) || 30;
    var inEditor = !!(window.Shopify && window.Shopify.designMode);

    function popupSeen() {
      try {
        var until = localStorage.getItem(popupKey);
        return !!until && parseInt(until, 10) > Date.now();
      } catch (error) {
        return false;
      }
    }

    function rememberPopup() {
      if (inEditor) return;
      try {
        localStorage.setItem(popupKey, String(Date.now() + rememberDays * 86400000));
      } catch (error) {
        /* private mode - the popup simply shows again next visit */
      }
    }

    function openPopup() {
      if (popup.dataset.open === 'true') return;
      popup.dataset.open = 'true';
      document.body.style.overflow = 'hidden';
      rememberPopup();
      var field = popup.querySelector('input[type="email"]');
      if (field) field.focus();
    }

    function closePopup() {
      popup.dataset.open = 'false';
      document.body.style.overflow = '';
    }

    // The signup form posts and reloads, so reopen to show the code or the error.
    var justPosted = popup.querySelector('.popup__code') || popup.querySelector('.form-message--error');

    if (justPosted) {
      openPopup();
    } else if (!popupSeen()) {
      setTimeout(openPopup, (parseInt(popup.dataset.delay, 10) || 0) * 1000);

      if (popup.dataset.exitIntent === 'true' && window.matchMedia('(min-width: 900px)').matches) {
        document.addEventListener('mouseout', function onExit(event) {
          if (event.clientY <= 0 && !event.relatedTarget) {
            openPopup();
            document.removeEventListener('mouseout', onExit);
          }
        });
      }
    }

    popup.addEventListener('click', function (event) {
      if (event.target === popup || event.target.closest('[data-popup-close]')) closePopup();
    });

    document.addEventListener('keydown', function (event) {
      if (event.key === 'Escape' && popup.dataset.open === 'true') closePopup();
    });
  }

  /* ------------------------------------------------------------ collection  */

  document.addEventListener('change', function (event) {
    var sort = event.target.closest('[data-sort-by]');
    if (!sort) return;
    var url = new URL(window.location.href);
    url.searchParams.set('sort_by', sort.value);
    url.searchParams.delete('page');
    window.location.href = url.toString();
  });
})();
